import { render, staticRenderFns } from "./ChartThirtyDayTopProductsByRevenue.vue?vue&type=template&id=735bec88&"
import script from "./ChartThirtyDayTopProductsByRevenue.vue?vue&type=script&lang=js&"
export * from "./ChartThirtyDayTopProductsByRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports